import generic from './generic'

const getDefaultState = () => {
  return {
    all: [],
    details: [],
    errored: false,
    loading: false,
    fetchedAt: null,
    ageLimit: 30,
  }
}

const state = getDefaultState()

const mutations = {
  ...generic.mutations,
  'RESET': function (state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  ...generic.actions,
  getAll (context) {
    return generic.getAll(context, {url: '/alliance/profile/'})
  },
  backgroundRefresh (context) {
    return generic.getAll(context, {url: '/alliance/profile/', hideLoading: true})
  },
}

const getters = {
  ...generic.getters,
  getDetailsByUsername: (state) => (username) => {
    return state.details.find(obj => obj.user === username)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
